const jobFinder = () => {
  const jobFinder = document.querySelector(".job-finder");
  if (!jobFinder) return;

  const jobExpertiseSelector = jobFinder.querySelector("select");
  if (!jobExpertiseSelector) return;

  const JobFinderButton = jobFinder.querySelector(".button-wrap > a");
  if (!JobFinderButton) return;
  const initialUrl = JobFinderButton.getAttribute("href");

  jobExpertiseSelector.addEventListener("change", function (e) {
    JobFinderButton.setAttribute("href", initialUrl + "?_sft_expertise=" + this.value);
  });
};

export default jobFinder;
